/**
 * Defines the input type for notes inspection items
 * Controls the keyboard type on mobile devices and input validation
 * Stored and serialized as string values
 */
export enum NotesInputType {
    /**
     * Standard text input (default)
     */
    Text = 'Text',

    /**
     * Numeric input only - shows numeric keyboard on mobile
     */
    Numeric = 'Numeric',
}
